package model

import utils.*
import utils.ff.Companion.println0

//import utils.ffVss
//import utils.ff

open class InventarioIte {
    var INV_EMPRESA = 0
    var INV_CODIGO = 0
    var INV_PRODUTO = 0
    var INV_GRADE = 0
    var INV_QTD = 0.0
    var INV_DTPROCESSAMENTO = ff.InicialDate

    var ESTG_EAN1 = ""
    var ESTG_EAN2 = ""
    var ESTG_EAN3 = ""

    var EST_BARRAOFICIAL = ""
    var ESTG_TIPO = ""
    var ESTG_EAN = ""
    var ESTG_UNIDVENDA = 0.0
    var EST_SALDO = 0.0
    var PRO_CXEMBARQUE = ""
    var OO_DESCRCOMPLETA = ""

    var OO_PRODUTO = ""
    var OO_UNIDVENDA = 0.0
    var OO_TIPO = ""

    fun construtorLista(_it: String): List<InventarioIte> {

        //var iLinha = 0
        //ff.println0("iniciou construtorLista")

        val lObj = ArrayList<InventarioIte>()
        if ((!_it.equals(null)) && (!_it.equals(""))) {
            val it = if (_it.ffCopy(0,1).equals("[")) _it else "[$_it]"
            //ff.println0("Zuza aqui ${it.ffCopy(0,1)} ${it.ffCopy(1,1)}")
            //ff.println0("Zuza aqui 11 " + it)
            val lista = JSON.parse<Array<dynamic>>(it)
            //ff.println0("Zuza aqui1 " + it)

            try {
                lista.forEach {
                    val o = InventarioIte()

                    o.INV_EMPRESA = it.INV_EMPRESA.toString().ffVsi()
                    o.INV_CODIGO = it.INV_CODIGO.toString().ffVsi()
                    o.INV_PRODUTO = it.INV_PRODUTO.toString().ffVsi()
                    o.INV_GRADE = it.INV_GRADE.toString().ffVsi()
                    o.INV_QTD = it.INV_QTD.toString().ffVsdo()
                    o.INV_DTPROCESSAMENTO = it.INV_DTPROCESSAMENTO.toString().ffDsd()

                    o.ESTG_EAN1 = it.ESTG_EAN1.toString().ffVss()
                    o.ESTG_EAN2 = it.ESTG_EAN2.toString().ffVss()
                    o.ESTG_EAN3 = it.ESTG_EAN3.toString().ffVss()

                    o.EST_BARRAOFICIAL = it.EST_BARRAOFICIAL.toString()
                    o.ESTG_TIPO = it.ESTG_TIPO.toString()
                    o.ESTG_EAN = it.ESTG_EAN.toString()
                    o.ESTG_UNIDVENDA = it.ESTG_UNIDVENDA.toString().ffVsdo()
                    o.EST_SALDO = it.EST_SALDO.toString().ffVsdo()
                    o.PRO_CXEMBARQUE = it.PRO_CXEMBARQUE.toString()
                    o.OO_DESCRCOMPLETA = it.OO_DESCRCOMPLETA.toString()

                    o.OO_PRODUTO = o.INV_PRODUTO.ffZeroLeft(6) + " - " + o.OO_DESCRCOMPLETA

                    lObj.add(o)
                }
            } catch (e: Exception) {
                println("catch do Inventarioite()" + e.message)
            }
        }
        //println0(lObj)
        ff.println0("Terminou construtorLista")
        return lObj
    }

    fun getInventarioItens(_recurso: String, cb: (List<InventarioIte>) -> Unit) {

        Service().getString(_recurso) { _sResult ->
            cb(construtorLista(_sResult))
        }

    }

    fun reg(_produto: String, _linvIte: List<InventarioIte>): InventarioIte? {

        var obj: InventarioIte? = null
        var sProduto = Produto().verEan(_produto)

        if (sProduto.equals("")) {
            sProduto = _produto
        }

        obj = _linvIte.filter({ p -> p.INV_PRODUTO == sProduto.ffVsi() }).toList().getOrNull(0)
        if (obj != null) {
            obj.OO_UNIDVENDA = obj.ESTG_UNIDVENDA
            obj.OO_TIPO = obj.ESTG_TIPO
        }

        //if (sProduto.length > 6) {
            if (obj == null) {
                obj = _linvIte.filter({ p -> p.ESTG_EAN1.contains("|EAN=$sProduto|") }).getOrNull(0)
                if (obj != null) {
                    obj.OO_UNIDVENDA = obj.ESTG_EAN1.ffPegaCampo("|UNIDVENDA=").ffVsc()
                    obj.OO_TIPO = obj.ESTG_EAN1.ffPegaCampo("|TIPO=")
                }
            }
            if (obj == null) {
                obj = _linvIte.filter({ p -> p.ESTG_EAN2.contains("|EAN=$sProduto|") }).getOrNull(0)
                if (obj != null) {
                    obj.OO_UNIDVENDA = obj.ESTG_EAN2.ffPegaCampo("|UNIDVENDA=").ffVsc()
                    obj.OO_TIPO = obj.ESTG_EAN2.ffPegaCampo("|TIPO=")
                }
            }
            if (obj == null) {
                obj = _linvIte.filter({ p -> p.ESTG_EAN3.contains("|EAN=$sProduto|") }).getOrNull(0)
                if (obj != null) {
                    obj.OO_UNIDVENDA = obj.ESTG_EAN3.ffPegaCampo("|UNIDVENDA=").ffVsc()
                    obj.OO_TIPO = obj.ESTG_EAN3.ffPegaCampo("|TIPO=")
                }
            }
        //}
        if (obj != null && obj.OO_UNIDVENDA == 0.0)
            obj.OO_UNIDVENDA = 1.0

        //println0("@investigar retorno 9999")
        //println0(obj)
        return obj

    }

}